export const GridRemoteConstant = {
  filter: false,
  pagination: false,
  sort: true,
  cellEdit: false,
};
